"use client";

import { medimoQC } from "@medimo/core-api/internal/next";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

const UNREAD_STATUS_PATH = "/v2/notifications/unread-status";
const NOTIFICATIONS_LIST_PATH = "/v2/notifications";

// サイドメニューの赤バッジ用。本文込みの一覧APIではなく専用のEXISTS APIを使う
export const useUnreadStatus = () => {
  const { data } = medimoQC.useQuery("get", "/v2/notifications/unread-status");
  return { exists: data?.exists ?? false };
};

// 既読化（わかりました押下・詳細ページ閲覧）の成功後にバッジと一覧を再検証して消すためのフック
export const useInvalidateUnreadStatus = () => {
  const queryClient = useQueryClient();
  return useCallback(
    () =>
      queryClient.invalidateQueries({
        predicate(query) {
          const [method, path] = query.queryKey;
          return (
            method === "get" &&
            (path === UNREAD_STATUS_PATH || path === NOTIFICATIONS_LIST_PATH)
          );
        },
      }),
    [queryClient],
  );
};
